import { styled } from "@mui/system";
export const AdministrationStyles = styled("div")(({ theme }) => ({
	"& >:nth-of-type(odd)": {
		background: "#f0f0f0",
	},
	"& > *": {
		padding: "10px",
	},
}));
